module.exports = __webpack_public_path__ + "img/varoszoba_enterior_1.62223292.jpg";